export let syncData = [
  {
    text: 0,
    start: 18,
    scroll: 30,
    scrollmob: 30,
  },
  {
    text: 1,
    start: 34,
    scroll: 60,
    scrollmob: 60,
  },
  {
    text: 2,
    start: 47,
    scroll: 90,
    scrollmob: 90,
  },
  {
    text: 3,
    start: 62,
    scroll: 120,
    scrollmob: 120,
  },
  {
    text: 4,
    start: 82,
    scroll: 150,
    scrollmob: 150,
  },
  {
    text: 5,
    start: 94,
    scroll: 180,
    scrollmob: 180,
  },
  {
    text: 6,
    start: 105,
    scroll: 210,
    scrollmob: 210,
  },
  {
    text: 7,
    start: 111,
    scroll: 240,
    scrollmob: 240,
  },
  {
    text: 8,
    start: 133,
    scroll: 270,
    scrollmob: 270,
  },
  {
    text: 9,
    start: 143,
    scroll: 300,
    scrollmob: 300,
  },
  {
    text: 10,
    start: 152,
    scroll: 330,
    scrollmob: 330,
  },
  {
    text: 11,
    start: 160,
    scroll: 360,
    scrollmob: 360,
  },
  {
    text: 12,
    start: 216,
    scroll: 390,
    scrollmob: 450,
  },
  {
    text: 13,
    start: 220,
    scroll: 420,
    scrollmob: 480,
  },
  {
    text: 14,
    start: 225,
    scroll: 450,
    scrollmob: 530,
  },
  {
    text: 15,
    start: 233,
    scroll: 480,
    scrollmob: 586,
  },
  {
    text: 16,
    start: 241,
    scroll: 510,
    scrollmob: 642,
  },
  {
    text: 17,
    start: 250,
    scroll: 540,
    scrollmob: 698,
  },
  {
    text: 18,
    start: 258,
    scroll: 570,
    scrollmob: 754,
  },
  {
    text: 19,
    start: 268,
    scroll: 600,
    scrollmob: 810,
  },
  {
    text: 20,
    start: 276,
    scroll: 630,
    scrollmob: 866,
  },
  {
    text: 21,
    start: 284,
    scroll: 660,
    scrollmob: 922,
  },
  {
    text: 22,
    start: 294,
    scroll: 690,
    scrollmob: 978,
  },
  {
    text: 23,
    start: 302,
    scroll: 720,
    scrollmob: 1034,
  },
  {
    text: 24,
    start: 310,
    scroll: 750,
    scrollmob: 1090,
  },
  {
    text: 25,
    start: 319,
    scroll: 780,
    scrollmob: 1146,
  },
  {
    text: 26,
    start: 328,
    scroll: 810,
    scrollmob: 1202,
  },
  {
    text: 27,
    start: 336,
    scroll: 840,
    scrollmob: 1258,
  },
  {
    text: 28,
    start: 345,
    scroll: 870,
    scrollmob: 1314,
  },
  {
    text: 29,
    start: 353,
    scroll: 900,
    scrollmob: 1370,
  },
  {
    text: 30,
    start: 362,
    scroll: 930,
    scrollmob: 1426,
  },
  {
    text: 31,
    start: 370,
    scroll: 960,
    scrollmob: 1482,
  },
  {
    text: 32,
    start: 379,
    scroll: 990,
    scrollmob: 1538,
  },
  {
    text: 33,
    start: 388,
    scroll: 1020,
    scrollmob: 1594,
  },
  {
    text: 34,
    start: 396,
    scroll: 1050,
    scrollmob: 1650,
  },
  {
    text: 35,
    start: 404,
    scroll: 1080,
    scrollmob: 1706,
  },
  {
    text: 36,
    start: 413,
    scroll: 1110,
    scrollmob: 1762,
  },
  {
    text: 37,
    start: 422,
    scroll: 1140,
    scrollmob: 1818,
  },
  {
    text: 38,
    start: 430,
    scroll: 1170,
    scrollmob: 1874,
  },
  {
    text: 39,
    start: 439,
    scroll: 1200,
    scrollmob: 1930,
  },
  {
    text: 40,
    start: 447,
    scroll: 1230,
    scrollmob: 1986,
  },
  {
    text: 41,
    start: 497,
    scroll: 1260,
    scrollmob: 2102,
  },
  {
    text: 42,
    start: 507,
    scroll: 1290,
    scrollmob: 2158,
  },
  {
    text: 43,
    start: 517,
    scroll: 1320,
    scrollmob: 2214,
  },
  {
    text: 44,
    start: 528,
    scroll: 1350,
    scrollmob: 2270,
  },
  {
    text: 45,
    start: 539,
    scroll: 1380,
    scrollmob: 2326,
  },
  {
    text: 46,
    start: 549,
    scroll: 1410,
    scrollmob: 2382,
  },
  {
    text: 47,
    start: 559,
    scroll: 1440,
    scrollmob: 2438,
  },
  {
    text: 48,
    start: 569,
    scroll: 1470,
    scrollmob: 2494,
  },
  {
    text: 49,
    start: 580,
    scroll: 1500,
    scrollmob: 2550,
  },
  {
    text: 50,
    start: 589,
    scroll: 1530,
    scrollmob: 2606,
  },
  {
    text: 51,
    start: 600,
    scroll: 1560,
    scrollmob: 2662,
  },
  {
    text: 52,
    start: 610,
    scroll: 1590,
    scrollmob: 2718,
  },
  {
    text: 53,
    start: 620,
    scroll: 1620,
    scrollmob: 2774,
  },
  {
    text: 54,
    start: 630,
    scroll: 1650,
    scrollmob: 2830,
  },
  {
    text: 55,
    start: 642,
    scroll: 1680,
    scrollmob: 2886,
  },
  {
    text: 56,
    start: 652,
    scroll: 1710,
    scrollmob: 2942,
  },
  {
    text: 57,
    start: 662,
    scroll: 1740,
    scrollmob: 2998,
  },
  {
    text: 58,
    start: 672,
    scroll: 1770,
    scrollmob: 3054,
  },
  {
    text: 59,
    start: 682,
    scroll: 1800,
    scrollmob: 3110,
  },
  {
    text: 60,
    start: 693,
    scroll: 1830,
    scrollmob: 3166,
  },
  {
    text: 61,
    start: 703,
    scroll: 1860,
    scrollmob: 3222,
  },
  {
    text: 62,
    start: 714,
    scroll: 1890,
    scrollmob: 3278,
  },
  {
    text: 63,
    start: 753,
    scroll: 1920,
    scrollmob: 3334,
  },
  {
    text: 64,
    start: 764,
    scroll: 1950,
    scrollmob: 3390,
  },
  {
    text: 65,
    start: 775,
    scroll: 1980,
    scrollmob: 3446,
  },
  {
    text: 66,
    start: 784,
    scroll: 2010,
    scrollmob: 3502,
  },
  {
    text: 67,
    start: 795,
    scroll: 2040,
    scrollmob: 3558,
  },
  {
    text: 68,
    start: 805,
    scroll: 2070,
    scrollmob: 3614,
  },
  {
    text: 69,
    start: 815,
    scroll: 2100,
    scrollmob: 3670,
  },
  {
    text: 70,
    start: 825,
    scroll: 2130,
    scrollmob: 3726,
  },
  {
    text: 71,
    start: 835,
    scroll: 2160,
    scrollmob: 3782,
  },
  {
    text: 72,
    start: 846,
    scroll: 2190,
    scrollmob: 3838,
  },
  {
    text: 73,
    start: 855,
    scroll: 2220,
    scrollmob: 3894,
  },
  {
    text: 74,
    start: 865,
    scroll: 2250,
    scrollmob: 3950,
  },
  {
    text: 75,
    start: 876,
    scroll: 2280,
    scrollmob: 4006,
  },
  {
    text: 76,
    start: 886,
    scroll: 2310,
    scrollmob: 4062,
  },
  {
    text: 77,
    start: 896,
    scroll: 2340,
    scrollmob: 4118,
  },
  {
    text: 78,
    start: 906,
    scroll: 2370,
    scrollmob: 4174,
  },
  {
    text: 79,
    start: 916,
    scroll: 2400,
    scrollmob: 4230,
  },
  {
    text: 80,
    start: 926,
    scroll: 2430,
    scrollmob: 4286,
  },
  {
    text: 81,
    start: 936,
    scroll: 2460,
    scrollmob: 4342,
  },
  {
    text: 82,
    start: 946,
    scroll: 2490,
    scrollmob: 4398,
  },
  {
    text: 83,
    start: 957,
    scroll: 2520,
    scrollmob: 4454,
  },
  {
    text: 84,
    start: 967,
    scroll: 2550,
    scrollmob: 4510,
  },
  {
    text: 85,
    start: 977,
    scroll: 2580,
    scrollmob: 4566,
  },
  {
    text: 86,
    start: 987,
    scroll: 2610,
    scrollmob: 4622,
  },
  {
    text: 87,
    start: 997,
    scroll: 2640,
    scrollmob: 4678,
  },
  {
    text: 88,
    start: 1042,
    scroll: 2990,
    scrollmob: 4795,
  },
  {
    text: 89,
    start: 1053,
    scroll: 2990,
    scrollmob: 4851,
  },
  {
    text: 90,
    start: 1063,
    scroll: 3020,
    scrollmob: 4907,
  },
  {
    text: 91,
    start: 1074,
    scroll: 3050,
    scrollmob: 4963,
  },
  {
    text: 92,
    start: 1084,
    scroll: 3080,
    scrollmob: 5019,
  },
  {
    text: 93,
    start: 1094,
    scroll: 3110,
    scrollmob: 5075,
  },
  {
    text: 94,
    start: 1105,
    scroll: 3140,
    scrollmob: 5131,
  },
  {
    text: 95,
    start: 1115,
    scroll: 3170,
    scrollmob: 5187,
  },
  {
    text: 96,
    start: 1126,
    scroll: 3200,
    scrollmob: 5243,
  },
  {
    text: 97,
    start: 1136,
    scroll: 3230,
    scrollmob: 5299,
  },
  {
    text: 98,
    start: 1147,
    scroll: 3260,
    scrollmob: 5355,
  },
  {
    text: 99,
    start: 1157,
    scroll: 3290,
    scrollmob: 5411,
  },
  {
    text: 100,
    start: 1167,
    scroll: 3320,
    scrollmob: 5467,
  },
  {
    text: 101,
    start: 1178,
    scroll: 3350,
    scrollmob: 5523,
  },
  {
    text: 102,
    start: 1189,
    scroll: 3380,
    scrollmob: 5579,
  },
  {
    text: 103,
    start: 1199,
    scroll: 3410,
    scrollmob: 5635,
  },
  {
    text: 104,
    start: 1210,
    scroll: 3440,
    scrollmob: 5691,
  },
  {
    text: 105,
    start: 1219,
    scroll: 3470,
    scrollmob: 5747,
  },
  {
    text: 106,
    start: 1230,
    scroll: 3500,
    scrollmob: 5803,
  },
  {
    text: 107,
    start: 1241,
    scroll: 3530,
    scrollmob: 5859,
  },
  {
    text: 108,
    start: 1252,
    scroll: 3560,
    scrollmob: 5915,
  },
  {
    text: 109,
    start: 1261,
    scroll: 3590,
    scrollmob: 5971,
  },
  {
    text: 110,
    start: 1272,
    scroll: 3620,
    scrollmob: 6027,
  },
  {
    text: 111,
    start: 1282,
    scroll: 3650,
    scrollmob: 6083,
  },
  {
    text: 112,
    start: 1292,
    scroll: 3680,
    scrollmob: 6139,
  },
  {
    text: 113,
    start: 1327,
    scroll: 3710,
    scrollmob: 6256,
  },
  {
    text: 114,
    start: 1337,
    scroll: 3740,
    scrollmob: 6312,
  },
  {
    text: 115,
    start: 1347,
    scroll: 3770,
    scrollmob: 6368,
  },
  {
    text: 116,
    start: 1357,
    scroll: 3800,
    scrollmob: 6424,
  },
  {
    text: 117,
    start: 1367,
    scroll: 3830,
    scrollmob: 6480,
  },
  {
    text: 118,
    start: 1377,
    scroll: 3860,
    scrollmob: 6536,
  },
  {
    text: 119,
    start: 1387,
    scroll: 3890,
    scrollmob: 6592,
  },
  {
    text: 120,
    start: 1397,
    scroll: 3920,
    scrollmob: 6648,
  },
  {
    text: 121,
    start: 1407,
    scroll: 3950,
    scrollmob: 6704,
  },
  {
    text: 122,
    start: 1417,
    scroll: 3980,
    scrollmob: 6760,
  },
  {
    text: 123,
    start: 1427,
    scroll: 4010,
    scrollmob: 6816,
  },
  {
    text: 124,
    start: 1437,
    scroll: 4040,
    scrollmob: 6872,
  },
  {
    text: 125,
    start: 1447,
    scroll: 4070,
    scrollmob: 6928,
  },
  {
    text: 126,
    start: 1457,
    scroll: 4100,
    scrollmob: 6984,
  },
  {
    text: 127,
    start: 1467,
    scroll: 4130,
    scrollmob: 7040,
  },
  {
    text: 128,
    start: 1477,
    scroll: 4160,
    scrollmob: 7096,
  },
  {
    text: 129,
    start: 1487,
    scroll: 4190,
    scrollmob: 7152,
  },
  {
    text: 130,
    start: 1497,
    scroll: 4220,
    scrollmob: 7208,
  },
  {
    text: 131,
    start: 1507,
    scroll: 4250,
    scrollmob: 7264,
  },
  {
    text: 132,
    start: 1517,
    scroll: 4280,
    scrollmob: 7320,
  },
  {
    text: 133,
    start: 1527,
    scroll: 4310,
    scrollmob: 7376,
  },
  {
    text: 134,
    start: 1537,
    scroll: 4340,
    scrollmob: 7432,
  },
  {
    text: 135,
    start: 1547,
    scroll: 4370,
    scrollmob: 7488,
  },
  {
    text: 136,
    start: 1557,
    scroll: 4400,
    scrollmob: 7544,
  },
  {
    text: 137,
    start: 1567,
    scroll: 4430,
    scrollmob: 7600,
  },
  {
    text: 138,
    start: 1603,
    scroll: 4460,
    scrollmob: 7717,
  },
  {
    text: 139,
    start: 1613,
    scroll: 4490,
    scrollmob: 7773,
  },
  {
    text: 140,
    start: 1623,
    scroll: 4520,
    scrollmob: 7829,
  },
  {
    text: 141,
    start: 1633,
    scroll: 4550,
    scrollmob: 7885,
  },
  {
    text: 142,
    start: 1643,
    scroll: 4580,
    scrollmob: 7941,
  },
  {
    text: 143,
    start: 1653,
    scroll: 4610,
    scrollmob: 7997,
  },
  {
    text: 144,
    start: 1663,
    scroll: 4640,
    scrollmob: 8053,
  },
  {
    text: 145,
    start: 1672,
    scroll: 4670,
    scrollmob: 8109,
  },
  {
    text: 146,
    start: 1683,
    scroll: 4700,
    scrollmob: 8165,
  },
  {
    text: 147,
    start: 1693,
    scroll: 4730,
    scrollmob: 8221,
  },
  {
    text: 148,
    start: 1702,
    scroll: 4760,
    scrollmob: 8277,
  },
  {
    text: 149,
    start: 1712,
    scroll: 4790,
    scrollmob: 8333,
  },
  {
    text: 150,
    start: 1721,
    scroll: 4820,
    scrollmob: 8389,
  },
  {
    text: 151,
    start: 1731,
    scroll: 4850,
    scrollmob: 8445,
  },
  {
    text: 152,
    start: 1741,
    scroll: 4880,
    scrollmob: 8501,
  },
  {
    text: 153,
    start: 1751,
    scroll: 4910,
    scrollmob: 8557,
  },
  {
    text: 154,
    start: 1760,
    scroll: 4940,
    scrollmob: 8613,
  },
  {
    text: 155,
    start: 1771,
    scroll: 4970,
    scrollmob: 8669,
  },
  {
    text: 156,
    start: 1780,
    scroll: 5000,
    scrollmob: 8725,
  },
  {
    text: 157,
    start: 1817,
    scroll: 5380,
    scrollmob: 8842,
  },
  {
    text: 158,
    start: 1823,
    scroll: 5410,
    scrollmob: 8898,
  },
  {
    text: 159,
    start: 1833,
    scroll: 5440,
    scrollmob: 8954,
  },
  {
    text: 160,
    start: 1839,
    scroll: 5470,
    scrollmob: 9010,
  },
  {
    text: 161,
    start: 1849,
    scroll: 5500,
    scrollmob: 9066,
  },
  {
    text: 162,
    start: 1855,
    scroll: 5530,
    scrollmob: 9122,
  },
  {
    text: 163,
    start: 1865,
    scroll: 5560,
    scrollmob: 9178,
  },
  {
    text: 164,
    start: 1871,
    scroll: 5590,
    scrollmob: 9234,
  },
  {
    text: 165,
    start: 1882,
    scroll: 5620,
    scrollmob: 9290,
  },
  {
    text: 166,
    start: 1888,
    scroll: 5650,
    scrollmob: 9346,
  },
  {
    text: 167,
    start: 1897,
    scroll: 5680,
    scrollmob: 9402,
  },
  {
    text: 168,
    start: 1904,
    scroll: 5710,
    scrollmob: 9458,
  },
  {
    text: 169,
    start: 1914,
    scroll: 5740,
    scrollmob: 9514,
  },
  {
    text: 170,
    start: 1920,
    scroll: 5770,
    scrollmob: 9570,
  },
  {
    text: 171,
    start: 1930,
    scroll: 5800,
    scrollmob: 9626,
  },
  {
    text: 172,
    start: 1936,
    scroll: 5830,
    scrollmob: 9682,
  },
  {
    text: 173,
    start: 1946,
    scroll: 5860,
    scrollmob: 9738,
  },
  {
    text: 174,
    start: 1955,
    scroll: 5890,
    scrollmob: 9794,
  },
  {
    text: 175,
    start: 1963,
    scroll: 5920,
    scrollmob: 9850,
  },
  {
    text: 176,
    start: 1970,
    scroll: 5950,
    scrollmob: 9906,
  },
  {
    text: 177,
    start: 1979,
    scroll: 5980,
    scrollmob: 9962,
  },
  {
    text: 178,
    start: 1985,
    scroll: 6010,
    scrollmob: 10018,
  },
  {
    text: 179,
    start: 1995,
    scroll: 6040,
    scrollmob: 10074,
  },
  {
    text: 180,
    start: 2001,
    scroll: 6070,
    scrollmob: 10130,
  },
  {
    text: 181,
    start: 2011,
    scroll: 6100,
    scrollmob: 10186,
  },
  {
    text: 182,
    start: 2017,
    scroll: 6130,
    scrollmob: 10242,
  },
  {
    text: 183,
    start: 2027,
    scroll: 6160,
    scrollmob: 10298,
  },
  {
    text: 184,
    start: 2035,
    scroll: 6190,
    scrollmob: 10354,
  },
  {
    text: 185,
    start: 2041,
    scroll: 6220,
    scrollmob: 10410,
  },
  {
    text: 186,
    start: 2072,
    scroll: 6250,
    scrollmob: 10466,
  },
  {
    text: 187,
    start: 2082,
    scroll: 6280,
    scrollmob: 10522,
  },
  {
    text: 188,
    start: 2091,
    scroll: 6310,
    scrollmob: 10578,
  },
  {
    text: 189,
    start: 2100,
    scroll: 6340,
    scrollmob: 10634,
  },
  {
    text: 190,
    start: 2110,
    scroll: 6370,
    scrollmob: 10690,
  },
  {
    text: 191,
    start: 2120,
    scroll: 6400,
    scrollmob: 10746,
  },
  {
    text: 192,
    start: 2129,
    scroll: 6430,
    scrollmob: 10802,
  },
  {
    text: 193,
    start: 2138,
    scroll: 6460,
    scrollmob: 10858,
  },
  {
    text: 194,
    start: 2148,
    scroll: 6490,
    scrollmob: 10914,
  },
  {
    text: 195,
    start: 2157,
    scroll: 6520,
    scrollmob: 10970,
  },
  {
    text: 196,
    start: 2167,
    scroll: 6550,
    scrollmob: 11026,
  },
  {
    text: 197,
    start: 2176,
    scroll: 6580,
    scrollmob: 11082,
  },
  {
    text: 198,
    start: 2186,
    scroll: 6610,
    scrollmob: 11138,
  },
  {
    text: 199,
    start: 2195,
    scroll: 6640,
    scrollmob: 11194,
  },
  {
    text: 200,
    start: 2205,
    scroll: 6670,
    scrollmob: 11250,
  },
  {
    text: 201,
    start: 2214,
    scroll: 6700,
    scrollmob: 11306,
  },
  {
    text: 202,
    start: 2224,
    scroll: 6730,
    scrollmob: 11362,
  },
  {
    text: 203,
    start: 2233,
    scroll: 6760,
    scrollmob: 11418,
  },
  {
    text: 204,
    start: 2277,
    scroll: 6790,
    scrollmob: 11535,
  },
  {
    text: 205,
    start: 2286,
    scroll: 6820,
    scrollmob: 11591,
  },
  {
    text: 206,
    start: 2296,
    scroll: 6850,
    scrollmob: 11647,
  },
  {
    text: 207,
    start: 2305,
    scroll: 6880,
    scrollmob: 11703,
  },
  {
    text: 208,
    start: 2314,
    scroll: 6910,
    scrollmob: 11759,
  },
  {
    text: 209,
    start: 2323,
    scroll: 6940,
    scrollmob: 11815,
  },
  {
    text: 210,
    start: 2333,
    scroll: 6970,
    scrollmob: 11871,
  },
  {
    text: 211,
    start: 2343,
    scroll: 7000,
    scrollmob: 11927,
  },
  {
    text: 212,
    start: 2352,
    scroll: 7030,
    scrollmob: 11983,
  },
  {
    text: 213,
    start: 2361,
    scroll: 7060,
    scrollmob: 12039,
  },
  {
    text: 214,
    start: 2370,
    scroll: 7090,
    scrollmob: 12095,
  },
  {
    text: 215,
    start: 2380,
    scroll: 7120,
    scrollmob: 12151,
  },
  {
    text: 216,
    start: 2389,
    scroll: 7150,
    scrollmob: 12207,
  },
  {
    text: 217,
    start: 2398,
    scroll: 7180,
    scrollmob: 12263,
  },
  {
    text: 218,
    start: 2408,
    scroll: 7210,
    scrollmob: 12319,
  },
  {
    text: 219,
    start: 2417,
    scroll: 7240,
    scrollmob: 12375,
  },
  {
    text: 220,
    start: 2427,
    scroll: 7270,
    scrollmob: 12431,
  },
  {
    text: 221,
    start: 2436,
    scroll: 7300,
    scrollmob: 12487,
  },
  {
    text: 222,
    start: 2479,
    scroll: 7330,
    scrollmob: 12543,
  },
  {
    text: 223,
    start: 2489,
    scroll: 7360,
    scrollmob: 12599,
  },
  {
    text: 224,
    start: 2498,
    scroll: 7390,
    scrollmob: 12655,
  },
  {
    text: 225,
    start: 2508,
    scroll: 7420,
    scrollmob: 12711,
  },
  {
    text: 226,
    start: 2517,
    scroll: 7450,
    scrollmob: 12767,
  },
  {
    text: 227,
    start: 2526,
    scroll: 7480,
    scrollmob: 12823,
  },
  {
    text: 228,
    start: 2536,
    scroll: 7510,
    scrollmob: 12879,
  },
  {
    text: 229,
    start: 2546,
    scroll: 7540,
    scrollmob: 12935,
  },
  {
    text: 230,
    start: 2554,
    scroll: 7570,
    scrollmob: 12991,
  },
  {
    text: 231,
    start: 2564,
    scroll: 7600,
    scrollmob: 13047,
  },
  {
    text: 232,
    start: 2573,
    scroll: 7630,
    scrollmob: 13103,
  },
  {
    text: 233,
    start: 2583,
    scroll: 7660,
    scrollmob: 13159,
  },
  {
    text: 234,
    start: 2592,
    scroll: 7690,
    scrollmob: 13215,
  },
  {
    text: 235,
    start: 2601,
    scroll: 7720,
    scrollmob: 13271,
  },
  {
    text: 236,
    start: 2611,
    scroll: 7750,
    scrollmob: 13327,
  },
  {
    text: 237,
    start: 2621,
    scroll: 7780,
    scrollmob: 13383,
  },
  {
    text: 238,
    start: 2630,
    scroll: 7810,
    scrollmob: 13439,
  },
  {
    text: 239,
    start: 2638,
    scroll: 7840,
    scrollmob: 13495,
  },
  {
    text: 240,
    start: 2648,
    scroll: 7870,
    scrollmob: 13551,
  },
  {
    text: 241,
    start: 2657,
    scroll: 7900,
    scrollmob: 13607,
  },
  {
    text: 242,
    start: 2667,
    scroll: 7930,
    scrollmob: 13663,
  },
  {
    text: 243,
    start: 2676,
    scroll: 7960,
    scrollmob: 13719,
  },
  {
    text: 244,
    start: 2713,
    scroll: 8238,
    scrollmob: 13836,
  },
  {
    text: 245,
    start: 2722,
    scroll: 8273,
    scrollmob: 13892,
  },
  {
    text: 246,
    start: 2731,
    scroll: 8308,
    scrollmob: 13948,
  },
  {
    text: 247,
    start: 2740,
    scroll: 8343,
    scrollmob: 14004,
  },
  {
    text: 248,
    start: 2750,
    scroll: 8378,
    scrollmob: 14060,
  },
  {
    text: 249,
    start: 2759,
    scroll: 8413,
    scrollmob: 14116,
  },
  {
    text: 250,
    start: 2768,
    scroll: 8448,
    scrollmob: 14172,
  },
  {
    text: 251,
    start: 2778,
    scroll: 8483,
    scrollmob: 14228,
  },
  {
    text: 252,
    start: 2786,
    scroll: 8518,
    scrollmob: 14284,
  },
  {
    text: 253,
    start: 2797,
    scroll: 8553,
    scrollmob: 14401,
  },
  {
    text: 254,
    start: 2805,
    scroll: 8588,
    scrollmob: 14457,
  },
  {
    text: 255,
    start: 2814,
    scroll: 8623,
    scrollmob: 14513,
  },
  {
    text: 256,
    start: 2824,
    scroll: 8658,
    scrollmob: 14569,
  },
  {
    text: 257,
    start: 2833,
    scroll: 8693,
    scrollmob: 14625,
  },
  {
    text: 258,
    start: 2842,
    scroll: 8728,
    scrollmob: 14681,
  },
  {
    text: 259,
    start: 2851,
    scroll: 8763,
    scrollmob: 14737,
  },
  {
    text: 260,
    start: 2860,
    scroll: 8798,
    scrollmob: 14793,
  },
  {
    text: 261,
    start: 2870,
    scroll: 8833,
    scrollmob: 14849,
  },
  {
    text: 262,
    start: 2879,
    scroll: 8868,
    scrollmob: 14905,
  },
  {
    text: 263,
    start: 2888,
    scroll: 8903,
    scrollmob: 14961,
  },
  {
    text: 264,
    start: 2897,
    scroll: 8938,
    scrollmob: 15017,
  },
  {
    text: 265,
    start: 2907,
    scroll: 8973,
    scrollmob: 15073,
  },
  {
    text: 266,
    start: 2940,
    scroll: 9008,
    scrollmob: 15190,
  },
  {
    text: 267,
    start: 2948,
    scroll: 9043,
    scrollmob: 15246,
  },
  {
    text: 268,
    start: 2957,
    scroll: 9078,
    scrollmob: 15302,
  },
  {
    text: 269,
    start: 2966,
    scroll: 9113,
    scrollmob: 15358,
  },
  {
    text: 270,
    start: 2975,
    scroll: 9148,
    scrollmob: 15414,
  },
  {
    text: 271,
    start: 2984,
    scroll: 9183,
    scrollmob: 15470,
  },
  {
    text: 272,
    start: 2993,
    scroll: 9218,
    scrollmob: 15526,
  },
  {
    text: 273,
    start: 3001,
    scroll: 9253,
    scrollmob: 15582,
  },
  {
    text: 274,
    start: 3010,
    scroll: 9288,
    scrollmob: 15638,
  },
  {
    text: 275,
    start: 3020,
    scroll: 9323,
    scrollmob: 15694,
  },
  {
    text: 276,
    start: 3028,
    scroll: 9358,
    scrollmob: 15750,
  },
  {
    text: 277,
    start: 3037,
    scroll: 9393,
    scrollmob: 15806,
  },
  {
    text: 278,
    start: 3045,
    scroll: 9428,
    scrollmob: 15862,
  },
  {
    text: 279,
    start: 3055,
    scroll: 9463,
    scrollmob: 15979,
  },
  {
    text: 280,
    start: 3063,
    scroll: 9498,
    scrollmob: 16035,
  },
  {
    text: 281,
    start: 3097,
    scroll: 9533,
    scrollmob: 16152,
  },
  {
    text: 282,
    start: 3103,
    scroll: 9568,
    scrollmob: 16208,
  },
  {
    text: 283,
    start: 3110,
    scroll: 9603,
    scrollmob: 16264,
  },
  {
    text: 284,
    start: 3116,
    scroll: 9638,
    scrollmob: 16320,
  },
  {
    text: 285,
    start: 3123,
    scroll: 9673,
    scrollmob: 16376,
  },
  {
    text: 286,
    start: 3130,
    scroll: 9708,
    scrollmob: 16432,
  },
  {
    text: 287,
    start: 3137,
    scroll: 9743,
    scrollmob: 16488,
  },
  {
    text: 288,
    start: 3143,
    scroll: 9778,
    scrollmob: 16544,
  },
  {
    text: 289,
    start: 3150,
    scroll: 9813,
    scrollmob: 16600,
  },
  {
    text: 290,
    start: 3156,
    scroll: 9848,
    scrollmob: 16656,
  },
  {
    text: 291,
    start: 3164,
    scroll: 9883,
    scrollmob: 16712,
  },
  {
    text: 292,
    start: 3170,
    scroll: 9918,
    scrollmob: 16768,
  },
  {
    text: 293,
    start: 3177,
    scroll: 9953,
    scrollmob: 16824,
  },
  {
    text: 294,
    start: 3183,
    scroll: 9988,
    scrollmob: 16941,
  },
  {
    text: 295,
    start: 3190,
    scroll: 10023,
    scrollmob: 16997,
  },
  {
    text: 296,
    start: 3196,
    scroll: 10058,
    scrollmob: 17053,
  },
  {
    text: 297,
    start: 3203,
    scroll: 10093,
    scrollmob: 17109,
  },
  {
    text: 298,
    start: 3210,
    scroll: 10128,
    scrollmob: 17165,
  },
  {
    text: 299,
    start: 3217,
    scroll: 10163,
    scrollmob: 17221,
  },
  {
    text: 300,
    start: 3223,
    scroll: 10198,
    scrollmob: 17277,
  },
  {
    text: 301,
    start: 3230,
    scroll: 10233,
    scrollmob: 17394,
  },
  {
    text: 302,
    start: 3236,
    scroll: 10268,
    scrollmob: 17450,
  },
  {
    text: 303,
    start: 3243,
    scroll: 10303,
    scrollmob: 17506,
  },
  {
    text: 304,
    start: 3249,
    scroll: 10338,
    scrollmob: 17562,
  },
  {
    text: 305,
    start: 3257,
    scroll: 10373,
    scrollmob: 17618,
  },
  {
    text: 306,
    start: 3263,
    scroll: 10408,
    scrollmob: 17674,
  },
  {
    text: 307,
    start: 3270,
    scroll: 10443,
    scrollmob: 17791,
  },
  {
    text: 308,
    start: 3276,
    scroll: 10478,
    scrollmob: 17847,
  },
  {
    text: 309,
    start: 3284,
    scroll: 10513,
    scrollmob: 17903,
  },
  {
    text: 310,
    start: 3290,
    scroll: 10548,
    scrollmob: 17959,
  },
  {
    text: 311,
    start: 3297,
    scroll: 10583,
    scrollmob: 18015,
  },
  {
    text: 312,
    start: 3304,
    scroll: 10618,
    scrollmob: 18132,
  },
  {
    text: 313,
    start: 3340,
    scroll: 10653,
    scrollmob: 18188,
  },
  {
    text: 314,
    start: 3346,
    scroll: 10688,
    scrollmob: 18244,
  },
  {
    text: 315,
    start: 3355,
    scroll: 10723,
    scrollmob: 18300,
  },
  {
    text: 316,
    start: 3361,
    scroll: 10758,
    scrollmob: 18356,
  },
  {
    text: 317,
    start: 3370,
    scroll: 10793,
    scrollmob: 18412,
  },
  {
    text: 318,
    start: 3376,
    scroll: 10828,
    scrollmob: 18468,
  },
  {
    text: 319,
    start: 3384,
    scroll: 10863,
    scrollmob: 18524,
  },
  {
    text: 320,
    start: 3391,
    scroll: 10898,
    scrollmob: 18580,
  },
  {
    text: 321,
    start: 3399,
    scroll: 10933,
    scrollmob: 18636,
  },
  {
    text: 322,
    start: 3405,
    scroll: 10968,
    scrollmob: 18692,
  },
  {
    text: 323,
    start: 3414,
    scroll: 11003,
    scrollmob: 18748,
  },
  {
    text: 324,
    start: 3420,
    scroll: 11038,
    scrollmob: 18804,
  },
  {
    text: 325,
    start: 3429,
    scroll: 11073,
    scrollmob: 18860,
  },
  {
    text: 326,
    start: 3435,
    scroll: 11108,
    scrollmob: 18916,
  },
  {
    text: 327,
    start: 3443,
    scroll: 11143,
    scrollmob: 18972,
  },
  {
    text: 328,
    start: 3450,
    scroll: 11178,
    scrollmob: 19028,
  },
  {
    text: 329,
    start: 3458,
    scroll: 11213,
    scrollmob: 19084,
  },
  {
    text: 330,
    start: 3464,
    scroll: 11248,
    scrollmob: 19140,
  },
  {
    text: 331,
    start: 3473,
    scroll: 11283,
    scrollmob: 19196,
  },
  {
    text: 332,
    start: 3480,
    scroll: 11318,
    scrollmob: 19252,
  },
  {
    text: 333,
    start: 3488,
    scroll: 11353,
    scrollmob: 19308,
  },
  {
    text: 334,
    start: 3494,
    scroll: 11388,
    scrollmob: 19364,
  },
  {
    text: 335,
    start: 3503,
    scroll: 11423,
    scrollmob: 19420,
  },
  {
    text: 336,
    start: 3509,
    scroll: 11458,
    scrollmob: 19476,
  },
  {
    text: 337,
    start: 3518,
    scroll: 11493,
    scrollmob: 19532,
  },
  {
    text: 338,
    start: 3524,
    scroll: 11528,
    scrollmob: 19588,
  },
  {
    text: 339,
    start: 3533,
    scroll: 11563,
    scrollmob: 19644,
  },
  {
    text: 340,
    start: 3538,
    scroll: 11598,
    scrollmob: 19700,
  },
  {
    text: 341,
    start: 3548,
    scroll: 11633,
    scrollmob: 19756,
  },
  {
    text: 342,
    start: 3553,
    scroll: 11668,
    scrollmob: 19812,
  },
  {
    text: 343,
    start: 3562,
    scroll: 11703,
    scrollmob: 19868,
  },
  {
    text: 344,
    start: 3568,
    scroll: 11738,
    scrollmob: 19924,
  },
  {
    text: 345,
    start: 3577,
    scroll: 11773,
    scrollmob: 19980,
  },
  {
    text: 346,
    start: 3583,
    scroll: 11808,
    scrollmob: 20036,
  },
  {
    text: 347,
    start: 3592,
    scroll: 11843,
    scrollmob: 20092,
  },
  {
    text: 348,
    start: 3598,
    scroll: 11878,
    scrollmob: 20148,
  },
  {
    text: 349,
    start: 3607,
    scroll: 11913,
    scrollmob: 20204,
  },
  {
    text: 350,
    start: 3614,
    scroll: 11948,
    scrollmob: 20260,
  },
  {
    text: 351,
    start: 3644,
    scroll: 11983,
    scrollmob: 20377,
  },
  {
    text: 352,
    start: 3653,
    scroll: 12018,
    scrollmob: 20433,
  },
  {
    text: 353,
    start: 3662,
    scroll: 12053,
    scrollmob: 20489,
  },
  {
    text: 354,
    start: 3670,
    scroll: 12088,
    scrollmob: 20545,
  },
  {
    text: 355,
    start: 3679,
    scroll: 12123,
    scrollmob: 20601,
  },
  {
    text: 356,
    start: 3688,
    scroll: 12158,
    scrollmob: 20718,
  },
  {
    text: 357,
    start: 3696,
    scroll: 12193,
    scrollmob: 20774,
  },
  {
    text: 358,
    start: 3705,
    scroll: 12228,
    scrollmob: 20830,
  },
  {
    text: 359,
    start: 3714,
    scroll: 12263,
    scrollmob: 20886,
  },
  {
    text: 360,
    start: 3722,
    scroll: 12298,
    scrollmob: 20942,
  },
  {
    text: 361,
    start: 3731,
    scroll: 12333,
    scrollmob: 20998,
  },
  {
    text: 362,
    start: 3740,
    scroll: 12368,
    scrollmob: 21054,
  },
  {
    text: 363,
    start: 3748,
    scroll: 12403,
    scrollmob: 21110,
  },
  {
    text: 364,
    start: 3757,
    scroll: 12438,
    scrollmob: 21166,
  },
  {
    text: 365,
    start: 3766,
    scroll: 12473,
    scrollmob: 21222,
  },
  {
    text: 366,
    start: 3774,
    scroll: 12508,
    scrollmob: 21278,
  },
  {
    text: 367,
    start: 3783,
    scroll: 12543,
    scrollmob: 21334,
  },
  {
    text: 368,
    start: 3792,
    scroll: 12578,
    scrollmob: 21390,
  },
  {
    text: 369,
    start: 3800,
    scroll: 12613,
    scrollmob: 21446,
  },
  {
    text: 370,
    start: 3809,
    scroll: 12648,
    scrollmob: 21502,
  },
  {
    text: 371,
    start: 3818,
    scroll: 12683,
    scrollmob: 21558,
  },
  {
    text: 372,
    start: 3826,
    scroll: 12718,
    scrollmob: 21614,
  },
  {
    text: 373,
    start: 3859,
    scroll: 12753,
    scrollmob: 21670,
  },
  {
    text: 374,
    start: 3867,
    scroll: 12788,
    scrollmob: 21726,
  },
  {
    text: 375,
    start: 3876,
    scroll: 12823,
    scrollmob: 21782,
  },
  {
    text: 376,
    start: 3885,
    scroll: 12858,
    scrollmob: 21838,
  },
  {
    text: 377,
    start: 3893,
    scroll: 12893,
    scrollmob: 21955,
  },
  {
    text: 378,
    start: 3902,
    scroll: 12928,
    scrollmob: 22011,
  },
  {
    text: 379,
    start: 3910,
    scroll: 12963,
    scrollmob: 22067,
  },
  {
    text: 380,
    start: 3919,
    scroll: 12998,
    scrollmob: 22123,
  },
  {
    text: 381,
    start: 3928,
    scroll: 13033,
    scrollmob: 22179,
  },
  {
    text: 382,
    start: 3937,
    scroll: 13068,
    scrollmob: 22296,
  },
  {
    text: 383,
    start: 3945,
    scroll: 13103,
    scrollmob: 22352,
  },
  {
    text: 384,
    start: 3954,
    scroll: 13138,
    scrollmob: 22408,
  },
  {
    text: 385,
    start: 3963,
    scroll: 13173,
    scrollmob: 22464,
  },
  {
    text: 386,
    start: 3971,
    scroll: 13208,
    scrollmob: 22520,
  },
  {
    text: 387,
    start: 3980,
    scroll: 13243,
    scrollmob: 22576,
  },
  {
    text: 388,
    start: 3989,
    scroll: 13278,
    scrollmob: 22632,
  },
  {
    text: 389,
    start: 4028,
    scroll: 13542,
    scrollmob: 22749,
  },
  {
    text: 390,
    start: 4034,
    scroll: 13572,
    scrollmob: 22805,
  },
  {
    text: 391,
    start: 4043,
    scroll: 13602,
    scrollmob: 22861,
  },
  {
    text: 392,
    start: 4048,
    scroll: 13632,
    scrollmob: 22917,
  },
  {
    text: 393,
    start: 4056,
    scroll: 13662,
    scrollmob: 22973,
  },
  {
    text: 394,
    start: 4062,
    scroll: 13692,
    scrollmob: 23029,
  },
  {
    text: 395,
    start: 4071,
    scroll: 13722,
    scrollmob: 23146,
  },
  {
    text: 396,
    start: 4076,
    scroll: 13752,
    scrollmob: 23202,
  },
  {
    text: 397,
    start: 4084,
    scroll: 13782,
    scrollmob: 23258,
  },
  {
    text: 398,
    start: 4090,
    scroll: 13812,
    scrollmob: 23314,
  },
  {
    text: 399,
    start: 4098,
    scroll: 13842,
    scrollmob: 23370,
  },
  {
    text: 400,
    start: 4104,
    scroll: 13872,
    scrollmob: 23426,
  },
  {
    text: 401,
    start: 4112,
    scroll: 13902,
    scrollmob: 23482,
  },
  {
    text: 402,
    start: 4118,
    scroll: 13932,
    scrollmob: 23538,
  },
  {
    text: 403,
    start: 4126,
    scroll: 13962,
    scrollmob: 23594,
  },
  {
    text: 404,
    start: 4132,
    scroll: 13992,
    scrollmob: 23650,
  },
  {
    text: 405,
    start: 4140,
    scroll: 14022,
    scrollmob: 23706,
  },
  {
    text: 406,
    start: 4146,
    scroll: 14052,
    scrollmob: 23762,
  },
  {
    text: 407,
    start: 4154,
    scroll: 14082,
    scrollmob: 23818,
  },
  {
    text: 408,
    start: 4160,
    scroll: 14112,
    scrollmob: 23874,
  },
  {
    text: 409,
    start: 4168,
    scroll: 14142,
    scrollmob: 23930,
  },
  {
    text: 410,
    start: 4174,
    scroll: 14172,
    scrollmob: 23986,
  },
  {
    text: 411,
    start: 4182,
    scroll: 14202,
    scrollmob: 24042,
  },
  {
    text: 412,
    start: 4187,
    scroll: 14232,
    scrollmob: 24098,
  },
  {
    text: 413,
    start: 4196,
    scroll: 14262,
    scrollmob: 24154,
  },
  {
    text: 414,
    start: 4201,
    scroll: 14292,
    scrollmob: 24210,
  },
  {
    text: 415,
    start: 4209,
    scroll: 14322,
    scrollmob: 24266,
  },
  {
    text: 416,
    start: 4243,
    scroll: 14517,
    scrollmob: 24383,
  },
  {
    text: 417,
    start: 4249,
    scroll: 14547,
    scrollmob: 24439,
  },
  {
    text: 418,
    start: 4257,
    scroll: 14577,
    scrollmob: 24495,
  },
  {
    text: 419,
    start: 4263,
    scroll: 14607,
    scrollmob: 24551,
  },
  {
    text: 420,
    start: 4270,
    scroll: 14637,
    scrollmob: 24668,
  },
  {
    text: 421,
    start: 4276,
    scroll: 14667,
    scrollmob: 24724,
  },
  {
    text: 422,
    start: 4284,
    scroll: 14697,
    scrollmob: 24780,
  },
  {
    text: 423,
    start: 4290,
    scroll: 14727,
    scrollmob: 24836,
  },
  {
    text: 424,
    start: 4298,
    scroll: 14757,
    scrollmob: 24953,
  },
  {
    text: 425,
    start: 4304,
    scroll: 14787,
    scrollmob: 25009,
  },
  {
    text: 426,
    start: 4312,
    scroll: 14817,
    scrollmob: 25065,
  },
  {
    text: 427,
    start: 4318,
    scroll: 14847,
    scrollmob: 25121,
  },
  {
    text: 428,
    start: 4327,
    scroll: 15059,
    scrollmob: 25238,
  },
  {
    text: 429,
    start: 4332,
    scroll: 15089,
    scrollmob: 25294,
  },
  {
    text: 430,
    start: 4340,
    scroll: 15109,
    scrollmob: 25350,
  },
  {
    text: 431,
    start: 4346,
    scroll: 15139,
    scrollmob: 25406,
  },
  {
    text: 432,
    start: 4354,
    scroll: 15167,
    scrollmob: 25462,
  },
  {
    text: 433,
    start: 4360,
    scroll: 15200,
    scrollmob: 25518,
  },
  {
    text: 434,
    start: 4368,
    scroll: 15230,
    scrollmob: 25574,
  },
  {
    text: 435,
    start: 4374,
    scroll: 15260,
    scrollmob: 25630,
  },
  {
    text: 436,
    start: 4382,
    scroll: 15290,
    scrollmob: 25686,
  },
  {
    text: 437,
    start: 4388,
    scroll: 15320,
    scrollmob: 25742,
  },
  {
    text: 438,
    start: 4416,
    scroll: 15350,
    scrollmob: 25798,
  },
  {
    text: 439,
    start: 4418,
    scroll: 15380,
    scrollmob: 25854,
  },
  {
    text: 440,
    start: 4421,
    scroll: 15384,
    scrollmob: 25910,
  },
  {
    text: 441,
    start: 4432,
    scroll: 15385,
    scrollmob: 25966,
  },
  {
    text: 442,
    start: 4437,
    scroll: 15386,
    scrollmob: 26022,
  },
  {
    text: 443,
    start: 4448,
    scroll: 15387,
    scrollmob: 26078,
  },
  {
    text: 444,
    start: 4453,
    scroll: 15388,
    scrollmob: 26134,
  },
  {
    text: 445,
    start: 4464,
    scroll: 15389,
    scrollmob: 26190,
  },
  {
    text: 446,
    start: 4470,
    scroll: 15390,
    scrollmob: 26246,
  },
  {
    text: 447,
    start: 4481,
    scroll: 15391,
    scrollmob: 26302,
  },
  {
    text: 448,
    start: 4486,
    scroll: 15392,
    scrollmob: 26358,
  },
  {
    text: 449,
    start: 4497,
    scroll: 15393,
    scrollmob: 26414,
  },
  {
    text: 450,
    start: 4502,
    scroll: 15394,
    scrollmob: 26470,
  },
  {
    text: 451,
    start: 4508,
    scroll: 15529,
    scrollmob: 26526,
  },
  {
    text: 452,
    start: 4508,
    scroll: 15529,
    scrollmob: 26582,
  },
];
